// 滚动加载
<template>
    <div class="loadList" v-loading="loading" element-loading-text="数据加载中">
        <slot name="cont">
        </slot>

        <slot name="empty" v-if="isEmpty">
            <empty-list>
                <span>暂无数据</span>
            </empty-list>
        </slot>

        <div class="gg_bottom">
            <div :ref="loadClass" :class="botclass" v-show="dataList.length >0">{{BidDynamicText}}</div>
        </div>
    </div>
</template>

<script>
import EmptyList from '@components/sys/empty-list';
import MODEL from '@/mixins/model';

export default {
    name: '',
    mixins: [MODEL],
    props: {
        action: {
            type: String,
            default: '',
        },
        pgForm: {
            type: Object,
            default: () => {},
        },
        value: {
            type: Array,
            default: () => [],
        },
        loadClass: {
            type: String,
            default: '',
        },
        afterClick: {
            type: Function,
            default: function () {},
        },
        isTagLong: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        botclass() {
            return { [this.loadClass]: true };
        },
        dataList: {
            get: function () {
                return this.value;
            },
            set: function (e) {
                this.$emit('input', e);
            },
        },
        BidDynamicText() {
            if (this.total > this.end) {
                return '向下滚动加载更多';
            } else {
                return '已经到底了';
            }
        },
    },
    components: {
        EmptyList,
    },
    data() {
        return {
            // dataList: [],
            dataListMaxpage: 0,
            total: 0,
            listLength: 0,
            end: 0,
            loading: true,
            isEmpty: false,
        };
    },
    mounted() {
        this.queryData();
    },
    methods: {
        itemClick(item, index) {
            !!this.afterClick && this.afterClick(item, index);
        },
        share(){
            this.queryData();
        },
        queryData(isClear = true) {
            this.loading = true;

            if(isClear){
                this.pgForm.pageIndex = 1
            }
            
            let that = this;
            let data = this.pgForm;

            this.$get(this.action, data, (data, res) => {
                this.dataListMaxpage = Math.ceil(data.total / data.pageSize);
                //第一次搜索，和后续搜索
                if (isClear) {
                    that.dataList = data.rows;
                    if (data.rows.length === 0) {
                        that.isEmpty = true;
                    } else {
                        that.isEmpty = false;
                    }
                } else {
                    data.rows.forEach(function (item) {
                        that.dataList.push(item);
                    });
                }
                this.end = data.end;
                this.total = data.total;
                this.loading = false;

                this.$emit('queryDataAfter', {
                    maxPage: this.dataListMaxpage,
                    nowPage: this.pgForm.pageIndex,
                    total: data.total,
                }); //请求结束。
            });
        },

        yzqthandleScroll() {
            let databottom = document.querySelector(`.${this.loadClass}`);
            if (!databottom) {
                return;
            }
            if (databottom.style.display == 'none') {
                return;
            } // 判断 有没有隐藏。隐藏返回。

            let seeHeight = document.documentElement.clientHeight; //当前页面可见区域高度 √
            let toTop = databottom.getBoundingClientRect().top; //距离顶部高度 ;

            if (toTop <= seeHeight && toTop != '0') {
                if (this.pgForm.pageIndex < this.dataListMaxpage) {
                    this.pgForm.pageIndex++;
                    this.queryData(false);
                }
            }
        },

        //跳转页面
        titleClick(data) {
            this.$emit('titleClick', data);
        },

        // 节流 计时器  防止出现 push 顺序错乱
        throttle(fn, time) {
            let timer = null;
            time = time || 1000;
            return function (...args) {
                if (timer) {
                    return;
                }
                const _this = this;
                timer = setTimeout(() => {
                    timer = null;
                }, time);
                fn.apply(_this, args);
            };
        },
    },
    beforeMount() {
        window.addEventListener('wheel', this.throttle(this.yzqthandleScroll, 360)); //其他业主信息
    },
    beforeDestroy() {
        window.removeEventListener('wheel', this.yzqthandleScroll); //其他业主信息
    },
};
</script>

<style lang="scss" scoped>
.loadList {
    min-height: 200px;
}
.items {
    margin-bottom: 20px;
    ::v-deep .title {
        width: 100%;
    }
}
.gg_bottom {
    margin: 20px auto;
    margin-bottom: 10px;
    text-align: center;
    color: #909399;
}
</style>
